import { Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import StatusBar from '@/designs-dev/device/StatusBar';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import Navigation from '@/karehero-app/shell/Navigation';
import Body from '@/karehero-app/shell/Body';
import { CARE_PROFILE } from '@/karehero-app/tell-us-once/intake/content';
import ArticleCard from '@/karehero-app/home/ArticleCard';
import { ARCHITECTURE_HELP } from '@/karehero-app/architecture/Architecture.content';

const noop = () => {};

// PROPOSED. Being stuck has one tab.
//
// The master has a Chat tab and articles on home, which asks somebody who is
// stuck to work out whether their problem is a reading problem or a talking
// problem before they can go anywhere. Both are here, and talking is first: a
// person who opens Help usually wants a person.
const ArchitectureHelp = ({
  onNotifications,
  onTalk,
  title = CARE_PROFILE.person,
  onSwitch,
}: {
  onNotifications?: () => void;
  /** Opens the chat. */
  onTalk?: () => void;
  /** Who the bar names. The architecture concepts pass whoever was picked. */
  title?: string;
  /** Someone else picked in the bar's switcher. See Navigation's `onSwitch`. */
  onSwitch?: (name: string) => void;
} = {}) => (
  <ScreenRoot>
    <StatusBar />

    <Navigation
      title={title}
      onNotifications={onNotifications}
      avatarInitials='OP'
      onSwitch={onSwitch}
    />

    <Body>
      <Stack spacing={2}>
        <Button
          variant='primary'
          size='lg'
          isFullWidth
          ariaLabel={ARCHITECTURE_HELP.talk}
          onPress={onTalk ?? noop}
        >
          {ARCHITECTURE_HELP.talk}
        </Button>

        <Typography sx={{ pt: 1 }} variant='h3'>
          {ARCHITECTURE_HELP.articlesTitle}
        </Typography>

        {ARCHITECTURE_HELP.articles.map((article) => (
          <ArticleCard
            key={article.id}
            title={article.title}
            summary={article.summary}
            onClick={noop}
          />
        ))}
      </Stack>
    </Body>
  </ScreenRoot>
);

export default ArchitectureHelp;
